import { SuppressedDefaultActionLink, Tag } from "@snapchat/web-core-ui";
import { getClassName } from "@snapchat/web-sds-c";
import clsx from "clsx";
import styles from "./TagBanner.module.css";
import React from "react";
function getLinkedTag(urlLink, isSelected, tagLabel, index, onSelect, logLinkClick) {
    return (<div className={clsx(styles.unselectedTag, {
            [styles.selectedTag]: isSelected,
        })} data-testid={`tagBannerTagLink_${index}`} key={`linkedTag-${index}`}>
      <span className={styles.link}>
        <SuppressedDefaultActionLink link={urlLink} logMetric={logLinkClick}>
          <Tag isSelected={isSelected} onSelect={onSelect} text={<span className={getClassName("H7", true)}>{tagLabel}</span>}/>
        </SuppressedDefaultActionLink>
      </span>
    </div>);
}
function getTag(isSelected, tagLabel, index, onSelect) {
    return (<div className={clsx(styles.unselectedTag, {
            [styles.selectedTag]: isSelected,
        })} data-testid={`tagBannerTag_${index}`} key={`tag-${index}`}>
      <Tag isSelected={isSelected} onSelect={onSelect} text={<span className={getClassName("H7", true)}>{tagLabel}</span>}/>
    </div>);
}
export function TagBanner(props) {
    return (<div className={styles.bannerContainer} data-testid="tagBanner">
      {props.tagItems.map((tagItem) => tagItem.link
            ? getLinkedTag(tagItem.link, tagItem.isSelected, tagItem.label, tagItem.index, tagItem.onSelect, tagItem.logLinkClick)
            : getTag(tagItem.isSelected, tagItem.label, tagItem.index, tagItem.onSelect))}
      {props.children}
    </div>);
}
